import { createFileRoute, redirect } from '@tanstack/react-router';
import { PermissionSetsTab } from '@/app/(client)/company-settings/-components/permissionSets/PermissionSetsTab';
import { ensurePermissions } from '@/hooks/usePermissions';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute(
  '/(client)/company-settings/(pages)/permission-sets/',
)({
  // `permission-access:read`, which every route under /permissions asks for —
  // without it the tab renders empty tables built from 403s. Reader and
  // Creator both hold it by default, so this is not an admin gate; it is the
  // one action that opens the screen.
  beforeLoad: async () => {
    const perms = await ensurePermissions();
    if (!perms['permission-access'].canRead) {
      throw redirect({ to: '/company-settings/users' });
    }
  },
  component: PermissionSetsRoute,
});

function PermissionSetsRoute() {
  const companyId = useSessionStore(s => s.user?.companyId);
  if (!companyId) return null;
  return <PermissionSetsTab companyId={companyId} />;
}
